const value = {
    title: 'Service Temporarily Unavailable',
    message:
      'We are aware of the problem and are working to get everything back up and running as soon as possible. If you have any questions or want to clarify ETAs, please feel free to contact our support team:',
  };

export default value;
